/* CB Golf Performance — global UI */
(function () {
  var nav = document.getElementById('nav');
  var prog = document.getElementById('progress');
  var sticky = document.getElementById('stickycta');

  function onScroll() {
    var y = window.scrollY;
    var h = document.documentElement.scrollHeight - window.innerHeight;
    if (prog) prog.style.width = (h > 0 ? (y / h * 100) : 0) + '%';
    if (nav) nav.classList.toggle('solid', y > 60);
    if (sticky) sticky.classList.toggle('show', y > window.innerHeight * 0.9);
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();

  // mobile nav toggle — event delegation so it works on every page regardless of render timing
  document.addEventListener('click', function (e) {
    var hit = e.target.closest ? e.target.closest('.nav__toggle') : null;
    if (hit) {
      e.preventDefault();
      var links = document.getElementById('navlinks');
      if (links) links.classList.toggle('open');
    }
  });

  // reveal on scroll
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); }
      });
    }, { threshold: 0.18 });
    document.querySelectorAll('.reveal').forEach(function (el) { io.observe(el); });

    // animated counters
    var cio = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (!e.isIntersecting) return;
        var el = e.target, end = +el.dataset.count, suf = el.dataset.suffix || '', t0 = null;
        function step(t) {
          if (!t0) t0 = t;
          var p = Math.min((t - t0) / 1100, 1);
          el.textContent = Math.round(p * end) + suf;
          if (p < 1) requestAnimationFrame(step);
        }
        requestAnimationFrame(step);
        cio.unobserve(el);
      });
    }, { threshold: 0.6 });
    document.querySelectorAll('[data-count]').forEach(function (c) { cio.observe(c); });
  } else {
    document.querySelectorAll('.reveal').forEach(function (el) { el.classList.add('in'); });
  }

  var yr = document.getElementById('yr');
  if (yr) yr.textContent = new Date().getFullYear();
})();
